<div class="pf-bg">
  <!-- Layer 2: Radial glows -->
  <div class="pf-bg__glow pf-bg__glow--top"></div>
  <div class="pf-bg__glow pf-bg__glow--bottom-right"></div>
  <div class="pf-bg__paper"></div>

  <!-- Layer 1: Grain texture; filter defined globally in index.html -->
  <svg class="pf-bg__grain" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect width="100%" height="100%" filter="url(#grain-filter)" />
  </svg>

  <!-- Layer 3: Nautical chart lines -->
  <svg
    class="pf-bg__lines"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1440 1024"
    preserveAspectRatio="xMidYMid slice"
  >
    <g class="pf-bg__lines-group">
      <path
        class="pf-bg__line pf-bg__line--soft"
        d="M-120 240 C 120 140, 280 180, 460 132 S 880 44, 1080 112 S 1380 194, 1560 92"
      />
      <path
        class="pf-bg__line"
        d="M-80 328 C 120 268, 304 316, 476 274 S 820 174, 1016 236 S 1310 332, 1520 242"
      />
      <path
        class="pf-bg__line pf-bg__line--soft"
        d="M-140 430 C 110 352, 312 420, 492 372 S 860 286, 1070 346 S 1340 436, 1570 356"
      />
      <path
        class="pf-bg__line"
        d="M-100 590 C 124 520, 316 560, 518 522 S 900 438, 1112 494 S 1370 584, 1560 526"
      />
      <path
        class="pf-bg__line pf-bg__line--soft"
        d="M-120 716 C 96 662, 302 700, 496 664 S 876 592, 1088 652 S 1364 736, 1540 690"
      />
      <path
        class="pf-bg__line pf-bg__line--route"
        d="M280 824 C 458 726, 634 660, 824 614 S 1142 476, 1320 332"
      />
      <path
        class="pf-bg__line pf-bg__line--route pf-bg__line--soft"
        d="M220 170 C 412 256, 602 320, 780 416 S 1074 598, 1220 754"
      />
    </g>

    <g class="pf-bg__grid-group">
      <line class="pf-bg__grid" x1="240" y1="-40" x2="240" y2="1064" />
      <line class="pf-bg__grid" x1="720" y1="-40" x2="720" y2="1064" />
      <line class="pf-bg__grid" x1="1200" y1="-40" x2="1200" y2="1064" />
      <line class="pf-bg__grid" x1="-40" y1="240" x2="1480" y2="240" />
      <line class="pf-bg__grid" x1="-40" y1="512" x2="1480" y2="512" />
      <line class="pf-bg__grid" x1="-40" y1="784" x2="1480" y2="784" />
    </g>

    <g class="pf-bg__compass" transform="translate(1110 186)">
      <circle class="pf-bg__compass-ring" r="84" />
      <circle class="pf-bg__compass-ring pf-bg__compass-ring--inner" r="52" />
      <path class="pf-bg__compass-star" d="M0 -92 L16 -16 L0 -52 L-16 -16 Z" />
      <path class="pf-bg__compass-star" d="M92 0 L16 16 L52 0 L16 -16 Z" />
      <path class="pf-bg__compass-star" d="M0 92 L-16 16 L0 52 L16 16 Z" />
      <path class="pf-bg__compass-star" d="M-92 0 L-16 -16 L-52 0 L-16 16 Z" />
      <path class="pf-bg__compass-star pf-bg__compass-star--soft" d="M0 -62 L9 -9 L0 -28 L-9 -9 Z" />
      <path class="pf-bg__compass-star pf-bg__compass-star--soft" d="M62 0 L9 9 L28 0 L9 -9 Z" />
      <path class="pf-bg__compass-star pf-bg__compass-star--soft" d="M0 62 L-9 9 L0 28 L9 9 Z" />
      <path class="pf-bg__compass-star pf-bg__compass-star--soft" d="M-62 0 L-9 -9 L-28 0 L-9 9 Z" />
      <line class="pf-bg__compass-axis" x1="0" y1="-108" x2="0" y2="108" />
      <line class="pf-bg__compass-axis" x1="-108" y1="0" x2="108" y2="0" />
      <text class="pf-bg__compass-label" x="0" y="-122">N</text>
      <text class="pf-bg__compass-label" x="122" y="5">E</text>
      <text class="pf-bg__compass-label" x="0" y="138">S</text>
      <text class="pf-bg__compass-label" x="-122" y="5">W</text>
    </g>
  </svg>
</div>
